import { create } from "zustand";
import { createJSONStorage, persist, StateStorage } from "zustand/middleware";
import { unifiedZustandStorage } from '../../../../../libs/helpers';
const storage = unifiedZustandStorage;



type State = {
  videoPanelExterior: string;
  videoCajas: string;
  videoCierreContenedor: string;
  dateVideoCajas: string | Date;
  dateVideoPanelExterior: string | Date;
  dateVideoCierreContenedor: string | Date;
  container: string;
};

type Action = {
  setVideoPanelExterior: (
    videoPanelExterior: State["videoPanelExterior"], src:boolean
  ) => void;
  setVideoCajas: (videoCajas: State["videoCajas"], src:boolean) => void;
  setVideoCierreContenedor: (
    videoCierreContenedor: State["videoCierreContenedor"], src:boolean
  ) => void;

  setContainer: (container: State["container"]) => void;
  // getVideos: () => Promise<State>;
  onClear: () => void;
};

// Create your store, which includes both state and (optionally) actions
export const useVideoStore = create<
  State & Action,
  [["zustand/persist", unknown]]
>(
  persist(
    (set, get) => ({
      container: "",
      videoPanelExterior: "",
      srcVideoPanelExterior: "",
      dateVideoPanelExterior: "",
      videoCajas: "",
      srcVideoCajas: "",
      dateVideoCajas: "",
      videoCierreContenedor: "",
      srcVideoCierreContenedor: "",
      dateVideoCierreContenedor: "",
      setVideoPanelExterior: (videoPanelExterior, src) => {
        if(src){
          set(() => ({
            videoPanelExterior,
            dateVideoPanelExterior: new Date(),
          }));

          return;
        }

        if (!videoPanelExterior) {
          set(() => ({
            videoPanelExterior: "",
            dateVideoPanelExterior: "",
          }));
          return;
        }
        // const reader = new FileReader();
        // reader.readAsDataURL(videoPanelExterior as unknown as Blob);
        // reader.onloadend = function () {
        //   const base64data = reader.result;
        //   set(() => ({
        //     videoPanelExterior: base64data as string,
        //     dateVideoPanelExterior: new Date(),
        //   }));
        // };
        const url = URL.createObjectURL(videoPanelExterior as unknown as Blob);
        set(() => ({
          videoPanelExterior: url as string,
          dateVideoPanelExterior: new Date(),
        }));
      },
      setVideoCajas: (videoCajas, src) => {
        if(src){
          set(() => ({
            videoCajas,
            dateVideoCajas: new Date(),
          }));

          return;
        }

        if (!videoCajas) {
          set(() => ({
            videoCajas: "",
            dateVideoCajas: "",
          }));
          return;
        }
        // const reader = new FileReader();
        // reader.readAsDataURL(videoCajas as unknown as Blob);
        // reader.onloadend = function () {
        //   const base64data = reader.result;
          // set(() => ({
          //   videoCajas: base64data as string,
          //   dateVideoCajas: new Date(),
          // }));
        // };
        const url = URL.createObjectURL(videoCajas as unknown as Blob);
        set(() => ({
          videoCajas: url as string,
          dateVideoCajas: new Date(),
        }));
      },
      setVideoCierreContenedor: async (videoCierreContenedor, src) => {
        if(src){
          set(() => ({
            videoCierreContenedor,
            dateVideoCierreContenedor: new Date(),
          }));

          return;
        }

        if (!videoCierreContenedor) {
          set(() => ({
            videoCierreContenedor: "",
            dateVideoCierreContenedor: "",
          }));
          return;
        }
        // const reader = new FileReader();
        // reader.readAsDataURL(videoCierreContenedor as unknown as Blob);
        // reader.onloadend = function () {
        //   const base64data = reader.result;
        //   set(() => ({
        //     videoCierreContenedor: base64data as string,
        //     dateVideoCierreContenedor: new Date(),
        //   }));
        // };
        const url = URL.createObjectURL(videoCierreContenedor as unknown as Blob);
        set(() => ({
          videoCierreContenedor: url as string,
          dateVideoCierreContenedor: new Date(),
        }));
      },
      setContainer: (container) => set(() => ({ container })),

      // getVideos: async () => {
      //   const vpe = await convertObjectURLToBase64(get().videoPanelExterior);
      //   const vce = await convertObjectURLToBase64(get().videoCajas);
      //   const vcc = await convertObjectURLToBase64(get().videoCierreContenedor);

      //   return {
      //     videoPanelExterior: vpe as string,
      //     videoCajas: vce as string,
      //     videoCierreContenedor: vcc as string,
      //     dateVideoPanelExterior: get().dateVideoPanelExterior,
      //     dateVideoCajas: get().dateVideoCajas,
      //     dateVideoCierreContenedor: get().dateVideoCierreContenedor,
      //     container: get().container,
      //   };
      // },
      onClear: () => {
        set(() => ({
          videoPanelExterior: "",
          videoCajas: "",
          videoCierreContenedor: "",
          dateVideoPanelExterior: "",
          dateVideoCajas: "",
          dateVideoCierreContenedor: "",
          container: "",
        }));
      },
    }),
    {
      name: "workflow-container-full-videos", // name of the item in the storage (must be unique)
      storage: createJSONStorage(() => storage), // (optional) by default, 'localStorage' is used
    }
  )
);

const convertObjectURLToBase64 = (objectURL:any) => {
  return fetch(objectURL)
    .then(response => response.blob())  // Obtienes el Blob
    .then(blob => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        
        reader.onloadend = () => {
          resolve(reader.result);  // El resultado es el base64
        };
        
        reader.onerror = reject;
        
        reader.readAsDataURL(blob);  // Convierte el Blob a base64
      });
    });
};
